module.exports = __webpack_public_path__ + "img/ap32-landing2-bg-mb.2fdfd4d9.png";